<script lang="ts" setup>

//vue
import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesContratosService";
import * as composicoesService from "@/services/contratosComposicoesService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";

import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";
import DropdownEmpresas from "@/components/Dropdowns/DropdownEmpresas.vue";
import DropdownClientes from "@/components/Dropdowns/DropdownClientes.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";
import Editor from '@tinymce/tinymce-vue'

import { fdataHora, fdataUS, fdataUSS, setaFocus } from "@/utils/funcoes";

  const route = useRoute();

  var controle = reactive({

    model: {
      
    } as service.Contrato,
    tipos: ['Familiar', 'Empresarial'] ,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],
    status2: [
      { texto: 'Pendente', valor: 1 },
      { texto: 'Ativo', valor: 2 }] as { texto: string; valor: number }[],
      erro: "",
      status: "",

      composicoes: [] as composicoesService.ContratoComposicao[],
      novaComposicaoClienteId: null as number | null,
      erroComposicao: "",
      statusComposicao: "",
  })

  onMounted(() => {

    console.log("buscar")
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then(r => {
          controle.model = r;
          buscarComposicoes();
        })
        .catch(error => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setaFocus("inputFocus");

  });

  function buscarComposicoes() {
    if (!controle.model.contratoId) return;

    composicoesService.obter({ contratoId: controle.model.contratoId } as composicoesService.Filtros)
      .then((r) => {
        controle.composicoes = r;
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao buscar composição: ${error}`;
      });
  }

  function adicionarComposicao() {
    if (!controle.novaComposicaoClienteId) {
      controle.erroComposicao = "Selecione um cliente!";
      return;
    }

    controle.statusComposicao = "Adicionando...";
    controle.erroComposicao = "";

    composicoesService.adicionar({
      contratoId: controle.model.contratoId,
      clienteId: controle.novaComposicaoClienteId,
      planoId: controle.model.planoId,
    } as composicoesService.ContratoComposicao)
      .then(() => {
        controle.statusComposicao = "";
        controle.novaComposicaoClienteId = null;
        buscarComposicoes();
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao adicionar: ${error}`;
        controle.statusComposicao = "";
      });
  }

  function excluirComposicao(item: composicoesService.ContratoComposicao) {
    composicoesService.excluir(item.id)
      .then(() => {
        buscarComposicoes();
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao excluir: ${error}`;
      });
  }

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      console.log("salvar", controle.model);

      if (controle.model.dataPriParcela != null)
        controle.model.dataPriParcela = fdataUSS(controle.model.dataPriParcela);

      if (controle.model.dataInicio != null)
        controle.model.dataInicio = fdataUSS(controle.model.dataInicio);
    
      if (controle.model.dataFim != null)
        controle.model.dataFim = fdataUSS(controle.model.dataFim);

      controle.status = "Gravando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)
       controle.model.contratoId = resultado.contratoId;
       buscarComposicoes();
       controle.status = "Gravado com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
  }

 
</script>

<template>
  <BreadCrumb PageTitle="Cadastro de Contratos" 
    :items="[ 
      { label: 'Contratos', to: '/contratos' }, 
      { label: 'Cadastro', to: '/contratos/cadastro' } ]" />

    <Notificacao :erro="controle.erro" 
          @limparErro="controle.erro=''" 
          :progresso="controle.status" 
          @limparProgresso="controle.status = ''" />

    <TrataTecla>
      <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-4">

          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-dados" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Básico</button>
              <button class="nav-link" id="nav-composicao-tab" data-bs-toggle="tab" data-bs-target="#nav-composicao" type="button" role="tab" aria-controls="nav-composicao" aria-selected="false">Composição</button>
              <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-contrato" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Contrato</button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane p-3 fade show active" id="nav-dados" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
              <div class="row">

                <!-- coluna 1-->
                <div class="col-md-6">
                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="clienteId" class="form-label">ID</label>
                    </div>
                    <div class="col-md-3">
                        <TextBox v-model="controle.model.contratoId" id="contratoId" :formato="'Numero'" readonly disabled />
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Plano</label>
                    </div>
                    <div class=col-md-9>
                      <DropdownPlanos v-model="controle.model.planoId"  />
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Vendedor</label>
                    </div>
                    <div class=col-md-9>
                      <DropdownUsuarios v-model="controle.model.vendedorId"  />
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Cliente</label>
                    </div>
                      <div class=col-md-9>
                        <DropdownClientes v-model="controle.model.clienteId"  />
                    </div>
                  </div>
                  
                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Investidor</label>
                    </div>
                    <div class=col-md-9>
                      <DropdownUsuarios v-model="controle.model.investidorId"  />
                    </div>
                  </div>

                  
                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Supervisor</label>
                    </div>
                    <div class=col-md-9>
                      <DropdownUsuarios v-model="controle.model.supervisorId"  />
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Empresa</label>
                    </div>
                    <div class=col-md-9>
                      <DropdownEmpresas v-model="controle.model.empresaId"  />
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Pré Contrato</label>
                    </div>
                      <div class=col-md-4>
                      <DropdownSimNao v-model="controle.model.preContrato" id="preContrato" class="form-select form-select-sm" />
                    </div>
                  </div>
                  
                </div>

                <!-- coluna 2-->
                <div class="col-md-6">
              
                

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="dt1Parcela" class="form-label">Dt 1º Parcela</label>
                    </div>
                    <div class=col-md-6>
                      <input :value="fdataUS(controle.model.dataPriParcela)" @input="(ev)=> controle.model.dataPriParcela = (ev.target as HTMLInputElement).value " id="dt1Parcela"  type="date" class="form-control form-control-sm"/>
                    </div>
                  </div>
                  
                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="dtInicio" class="form-label">Dt Inicio</label>
                    </div>
                    <div class=col-md-6>
                      <input :value="fdataUS(controle.model.dataInicio)" @input="(ev)=> controle.model.dataInicio = (ev.target as HTMLInputElement).value " id="dtInicio"  type="date" class="form-control form-control-sm"/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="dtFim" class="form-label">Dt Fim</label>
                    </div>
                    <div class=col-md-6>
                      <input :value="fdataUS(controle.model.dataFim)" @input="(ev)=> controle.model.dataFim = (ev.target as HTMLInputElement).value " id="dtFim"  type="date" class="form-control form-control-sm"/>
                    </div>
                  </div>


                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="dtAssinatura" class="form-label">Dt Assinatura</label>
                    </div>
                    <div class=col-md-6>
                      <div class="input-group ">
                        <input type="text" class="form-control" placeholder="Sem assinar" :value="fdataHora(controle.model.dataAssinatura)" >
                        <a class="btn btn-sm btn-secondary" @click="controle.model.dataAssinatura = null" title="Limpar para assinar novamente">
                          Limpar
                        </a>
                      </div>

                    
                      <!-- <input :value="fdataUS(controle.model.dataAssinatura)" @input="(ev)=> controle.model.dataAssinatura = (ev.target as HTMLInputElement).value " id="dtAssinatura"  type="date" class="form-control form-control-sm"/> -->

                    </div>
                    <div class="col-md-2">
                    </div>

                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="dtFim" class="form-label">Assinatura</label>
                    </div>
                    <div class=col-md-6>
                      <TextBox v-model="controle.model.assinatura" id="assinatura"  :formato="'Texto'" class=""/>
                    </div>
                  </div>

                 

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="observacoes" class="form-label">Observações</label>
                    </div>
                    <div class=col-md-6>
                      <TextBox v-model="controle.model.observacoes" id="observacoes"  :formato="'Texto'" class=""/>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-3">
                      <label for="ativo" class="form-label">Status</label>
                    </div>
                      <div class=col-md-4>
                      <select v-model="controle.model.statusId" id="statusId" class="form-select form-select-sm" >
                        <option v-for="tipo in controle.status2" :key="String(tipo.valor)" :value="tipo.valor">{{ tipo.texto }}</option>
                      </select>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="tab-pane p-3 fade" id="nav-composicao" role="tabpanel" aria-labelledby="nav-composicao-tab" tabindex="0">
              <template v-if="!controle.model.contratoId">
                <div class="row mb-2">
                  <div class="col-md-12">
                    <p>Necessário gravar o contrato antes de gerenciar a composição.</p>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label class="form-label">Cliente</label>
                    <DropdownClientes v-model="controle.novaComposicaoClienteId" />
                  </div>
                  <div class="col-md-2">
                    <a class="btn btn-sm btn-primary mt-4" @click="adicionarComposicao()">Adicionar</a>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <table class="table table-sm table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Cliente</th>
                          <th>Plano</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="controle.composicoes.length == 0">
                          <tr>
                            <td colspan="3" class="text-center">Nenhum registro</td>
                          </tr>
                        </template>
                        <tr v-for="(item, index) in controle.composicoes" :key="index">
                          <td>{{ item.cliente?.nome }}</td>
                          <td>{{ item.plano?.nome }}</td>
                          <td>
                            <a class="" title="Excluir" href="#" @click="excluirComposicao(item)">
                              <i class="flaticon-delete text-danger fs-5"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-12">
                    <p class="">Registros: {{ controle.composicoes.length }}</p>
                  </div>
                </div>

                <div class="text-center">
                  <span class="">{{ controle.statusComposicao }}</span>
                  <span class="text-danger fw-bold">{{ controle.erroComposicao }}</span>
                </div>
              </template>
            </div>
            <div class="tab-pane p-3 fade" id="nav-contrato" role="tabpanel" aria-labelledby="nav-profile-tab" tabindex="0">
                <div class="row mb-2">
                  <div class="col-md-12">
                    <label class="mb-2">Variáveis disponíveis: [ASSINATURACONTRATADA] [CLIENTENOME] [CLIENTENASCIMENTO] [CLIENTECPF] [CONJUGENOME] [CONJUGECPF] [ASSINATURA] [DIA] [MES] [ANO]</label>
                    <label for="texto" class="form-label">Texto do Contrato</label>
                    <editor
                      api-key="lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7"
                      :init="{
                        height: 700,
                        menubar: true,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                          alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help'
                      }"
                      v-model="controle.model.texto"
                      @update:modelValue="(value) => controle.model.texto = value"
                    />
                  </div>
                </div>
            </div>
          </div>

         
        </div>
        <div class='card-footer'>
          <div class="row">
             <div class="col-md-2">
              <a class="btn btn-sm btn-primary" @click="salvar()">Gravar</a>
            </div>

            
            <div class="col-md-4">
              <div v-if="controle.erro == null && controle.status != null" class="fw-bold">{{ controle.status }}</div>
              <div v-if="controle.erro != null " class="fw-bold text-danger">{{ controle.erro }}</div>
            </div>
            <div class="col-md-4">
            </div>

           <div class="col-md-2">
              <RouterLink class="btn btn-sm btn-secondary float-end" :to="'/contratos'">Fechar</RouterLink>
            </div>
          </div>
        </div>
      </div>
    </TrataTecla>

</template>